/**
 * nc-analytics-events.js — Émission des événements GA4 de génération de leads.
 *
 * Contrat (noms exacts, set fermé — work-order B5) :
 *   generate_lead        -> soumission RÉUSSIE d'un formulaire devis / contact
 *   contact_phone_click  -> clic sur un lien tel:
 *   contact_email_click  -> clic sur un lien mailto:
 *   cookie_consent       -> choix du bandeau cookies (dims : consent_action =
 *                           accept_all|reject_all|customize_save ; ad_consent,
 *                           analytics_consent = granted|denied). NB : un reject part
 *                           sous analytics denied -> non enregistré comme hit GA4
 *                           (modeling only). Le VRAI taux d'opt-in = beacon serveur
 *                           /consent (canal B, hors GA4), pas cet event.
 *   Dimensions perso GA4 (minuscules, casse-sensible) : consent_action, ad_consent,
 *   analytics_consent (à créer dans GA4 Admin).
 *
 * S'appuie sur window.gtag (initialisé par nc-consent-mode = Consent Mode v2).
 * Ce script émet toujours ; c'est gtag (Consent Mode) qui temporise tant que
 * analytics_storage est "denied". Le consentement est piloté par
 * nc-consent-mode.liquid (défaut) + nc-cookie-banner.js (update à l'acceptation).
 *
 * Chargé uniquement si settings.nc_ga4_measurement_id est renseigné (scripts.liquid).
 */
(function () {
  if (window.__ncAnalyticsEventsReady) return;
  window.__ncAnalyticsEventsReady = true;

  function emit(name, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  }

  // --- generate_lead -------------------------------------------------------
  // Mapping formId -> { form_name, lead_type } (valeurs du set fermé GA4).
  // Les formulaires hors set (alerte de prix #nc-alert-form, ventes flash
  // #nc-vf-form) ne déclenchent PAS generate_lead : ce ne sont pas les
  // conversions définies (devis + appel), et inventer une valeur casserait
  // le set fermé des dimensions.
  var LEAD_FORMS = {
    'nc-devis-form': { form_name: 'devis', lead_type: 'devis' },
    'HeroDevisForm': { form_name: 'devis', lead_type: 'devis' }
  };

  function leadMetaFor(formId) {
    if (LEAD_FORMS[formId]) return LEAD_FORMS[formId];
    // Formulaire de contact natif Shopify : id = "ContactForm-<...>"
    if (/^ContactForm/.test(formId)) return { form_name: 'contact', lead_type: 'contact' };
    return null;
  }

  function emitLead(meta) {
    if (!meta) return;
    emit('generate_lead', {
      form_name: meta.form_name,
      lead_type: meta.lead_type,
      value: 1,
      currency: 'EUR'
    });
  }

  // --- Enhanced Conversions (ECL) ------------------------------------------
  // Augmente la conversion generate_lead (déjà live) avec l'identité hashée du
  // prospect pour améliorer l'attribution au clic Ads. Posture 1 : uniquement si
  // consentement marketing (ad_user_data). Hachage SHA-256 hex CÔTÉ NAVIGATEUR ->
  // aucune donnée en clair n'est envoyée. gtag('set','user_data') avant l'event
  // pour que la conversion (GA4 + Ads via le tag combiné) reçoive les identifiants.
  // L'activation « Enhanced conversions » se fait côté compte Google Ads.
  function marketingConsent() {
    try { var s = JSON.parse(localStorage.getItem('nc-consent-v2') || 'null'); return !!(s && s.marketing); }
    catch (e) { return false; }
  }

  function normalizeEmail(v) {
    var e = String(v || '').trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) return '';
    var parts = e.split('@');
    if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
      parts[0] = parts[0].replace(/\./g, '');
    }
    return parts[0] + '@' + parts[1];
  }

  // Normalisation E.164 pour numéros FR ; on n'envoie rien si le format est douteux
  // (un hash de numéro mal formé dégrade le matching plutôt que de l'aider).
  function normalizePhoneFR(v) {
    var d = String(v || '').replace(/[^\d+]/g, '');
    if (/^\+[1-9]\d{6,14}$/.test(d)) return d;
    d = d.replace(/\D/g, '');
    if (d.length === 10 && d.charAt(0) === '0') return '+33' + d.slice(1);
    if (d.length === 11 && d.slice(0, 2) === '33') return '+' + d;
    return '';
  }

  function sha256Hex(str) {
    if (!(window.crypto && window.crypto.subtle && window.TextEncoder)) return Promise.resolve('');
    try {
      var buf = new TextEncoder().encode(str);
      return window.crypto.subtle.digest('SHA-256', buf).then(function (hash) {
        return Array.prototype.map.call(new Uint8Array(hash), function (b) {
          return ('0' + b.toString(16)).slice(-2);
        }).join('');
      }).catch(function () { return ''; });
    } catch (e) { return Promise.resolve(''); }
  }

  function setEnhancedUserData(form) {
    if (!form || typeof window.gtag !== 'function' || !form.querySelector) return Promise.resolve();
    var emailEl = form.querySelector('input[type="email"]');
    var phoneEl = form.querySelector('input[type="tel"]');
    var email = normalizeEmail(emailEl && emailEl.value);
    var phone = normalizePhoneFR(phoneEl && phoneEl.value);
    if (!email && !phone) return Promise.resolve();
    return Promise.all([
      email ? sha256Hex(email) : Promise.resolve(''),
      phone ? sha256Hex(phone) : Promise.resolve('')
    ]).then(function (h) {
      var data = {};
      if (h[0]) data.sha256_email_address = h[0];
      if (h[1]) data.sha256_phone_number = h[1];
      if (Object.keys(data).length) window.gtag('set', 'user_data', data);
    });
  }

  // Cas AJAX (Turnstile) : nc-turnstile-forms.js émet nc:lead-success sur succès réel
  // (HTTP ok + payload.success), jamais sur simple clic "envoyer". L'event bubble
  // depuis le <form> -> e.target = le formulaire (source de l'e-mail/tél pour l'ECL).
  document.addEventListener('nc:lead-success', function (e) {
    var meta = leadMetaFor((e.detail && e.detail.formId) || '');
    if (!meta) return;
    if (marketingConsent()) {
      setEnhancedUserData(e.target).then(function () { emitLead(meta); });
    } else {
      emitLead(meta);
    }
  });

  // Cas POST natif (Turnstile désactivé ou indisponible) : la section rend le
  // marqueur data-nc-lead-success UNIQUEMENT quand form.posted_successfully? est
  // vrai (rechargement serveur après envoi). Mutuellement exclusif avec le chemin
  // AJAX nc:lead-success (qui n'entraîne aucun rechargement) -> pas de double
  // comptage. Fallback sur .contact-form__success pour le formulaire contact natif
  // Shopify (thème Horizon), qui ne porte pas ce marqueur.
  function checkNativeContactSuccess() {
    var el = document.querySelector('[data-nc-lead-success]');
    if (el) {
      emitLead({
        form_name: el.getAttribute('data-nc-form-name') || 'contact',
        lead_type: el.getAttribute('data-nc-lead-type') || 'contact'
      });
      return;
    }
    if (document.querySelector('.contact-form__success')) {
      emitLead({ form_name: 'contact', lead_type: 'contact' });
    }
  }

  // --- contact_phone_click / contact_email_click ---------------------------
  function linkLocation(el) {
    if (el.closest('#header-group, header, .nc-hdr')) return 'header';
    if (el.closest('#footer-group, footer, .nc-footer')) return 'footer';
    return 'body';
  }

  // Écouteur délégué (phase capture) : couvre tous les liens, même injectés après coup.
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var tel = target.closest('a[href^="tel:"]');
    if (tel) {
      emit('contact_phone_click', {
        phone_number: tel.getAttribute('href').replace(/^tel:/i, '').trim(),
        link_location: linkLocation(tel)
      });
      return;
    }

    var mail = target.closest('a[href^="mailto:"]');
    if (mail) {
      emit('contact_email_click', { link_location: linkLocation(mail) });
    }
  }, true);

  // --- cookie_consent (canal A) --------------------------------------------
  // Émis à chaque choix du bandeau (nc-cookie-banner.js dispatche nc:consent-update).
  // Sert à segmenter les accepteurs et corréler avec generate_lead. Ne compte PAS
  // les refus (émis sous analytics denied) : le taux réel vient du beacon /consent.
  window.addEventListener('nc:consent-update', function (e) {
    var d = e.detail || {};
    emit('cookie_consent', {
      consent_action: d.action || 'unknown',
      ad_consent: d.marketing ? 'granted' : 'denied',
      analytics_consent: d.analytics ? 'granted' : 'denied'
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkNativeContactSuccess, { once: true });
  } else {
    checkNativeContactSuccess();
  }
})();
